import React from 'react';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Services } from '../components/Services';
import { Work } from '../components/Work';
import { Values } from '../components/Values';
import { Closer } from '../components/Closer';
export function Home() {
  return <>
      <Hero data-id="element-287" data-mp="2x4efbb106qhf" />
      <Marquee data-id="element-288" data-mp="2x56e0upwd4bx" />
      <Services data-id="element-289" data-mp="2x7sgwh1uevnt" />
      <Work data-id="element-290" data-mp="1zhxkqdjnmqzd" />
      <Values data-id="element-291" data-mp="1zi7e8b3wrg9t" />
      <Closer data-id="element-292" data-mp="1ziqvdplqi0ms" />
    </>;
}